export default {
  getAll: {
    url: '/api/payment/getAll',
    method: 'get'
  },
  create: {
    url: '/api/payment/create',
    method: 'post'
  },
  update: {
    url: '/api/payment/update',
    method: 'put'
  },
  delete: {
    url: '/api/payment/delete',
    method: 'delete'
  },
  getCustomerData: {
    url: '/api/payment/getCustomerData',
    method: 'get'
  }
}



// WEBPACK FOOTER //
// ./src/api/payment.js